import { Controller } from "@hotwired/stimulus"

const DEFAULT_COUNTRY_CODE = "+27"

export default class extends Controller {
  static targets = ["checkbox", "name", "mobile", "mobileCountryInput"]
  static values = {
    userName: String,
    userCountryCode: String,
    userMobileNumber: String
  }

  toggleAccountDetails(event) {
    if (!event.target.checked) return
    this.populateFromAccount()
  }

  populateFromAccount() {
    const name = this.userNameValue
    if (this.hasNameTarget && name) {
      this.nameTarget.value = name
    }

    const countryCode = this.normalizeCountryCode(this.userCountryCodeValue)
    if (this.hasMobileCountryInputTarget) {
      this.setCountryCode(countryCode)
    }

    if (this.hasMobileTarget && this.userMobileNumberValue) {
      const strippedNumber = this.stripCountryCode(this.userMobileNumberValue, countryCode)
      if (strippedNumber) {
        this.setMobileNumber(countryCode, strippedNumber)
      }
    }
  }

  setCountryCode(code) {
    if (!this.hasMobileCountryInputTarget) return
    const normalizedCode = this.normalizeCountryCode(code)
    this.mobileCountryInputTarget.value = normalizedCode

    const selectorElement = this.mobileCountryInputTarget.closest("[data-controller~='country-code-selector']")
    if (selectorElement) {
      const selectorController = this.application.getControllerForElementAndIdentifier(selectorElement, "country-code-selector")
      if (selectorController) {
        selectorController.selectedCode = normalizedCode
        selectorController.inputTarget.value = normalizedCode
        selectorController.updateButtonLabel()
        selectorController.dispatchChange()
        return
      }
    }

    this.dispatchCountryCodeChange(normalizedCode)
  }

  setMobileNumber(code, number) {
    const mobileElement = this.mobileTarget
    if (!mobileElement) return

    const sanitized = `${number}`.trim()
    if (!sanitized) return

    const composite = `${code} ${sanitized}`.trim()
    const container = mobileElement.closest("[data-controller~='mobile-number']")
    const mobileController = container ? this.application.getControllerForElementAndIdentifier(container, "mobile-number") : null

    if (mobileController) {
      mobileController.currentCode = code
      mobileController.digits = mobileController.extractDigits(composite)
      mobileController.applyMask()
    } else {
      mobileElement.value = composite
    }
  }

  dispatchCountryCodeChange(code) {
    if (!this.hasMobileCountryInputTarget) return
    const detail = {
      code,
      inputId: this.mobileCountryInputTarget.id
    }
    window.dispatchEvent(new CustomEvent("country-code:changed", { detail }))
  }

  stripCountryCode(number, countryCode) {
    if (!number) return ""
    const digits = `${number}`.replace(/\D+/g, "")
    const codeDigits = `${countryCode || ""}`.replace(/\D+/g, "")
    if (codeDigits && digits.startsWith(codeDigits)) {
      return digits.slice(codeDigits.length)
    }
    return digits
  }

  normalizeCountryCode(value) {
    const digits = `${value || ""}`.replace(/\D+/g, "")
    if (digits.length === 0) {
      return DEFAULT_COUNTRY_CODE
    }
    return `+${digits}`
  }
}
